// @flow

import React, {Component} from 'react'
import { connect } from 'react-redux'
import ReactGA from 'react-ga'
import { Link } from 'react-router-dom'

import { forgotPassword as SforgotPassword } from '../../../store/actions/Session'

import { Form, LinkButtonStyle } from './../../../styles'
import { Field, Button, User, Error, Success } from './../../../components'

class ForgotPassword extends Component {
  state = {
    waiting: false,
    error: '',
    success: '',
    formdata: {},
  }

  componentDidMount() {
    ReactGA.pageview('/forgot-password');
  }

  addFormData = (data) => {
    const { formData } = this.state
    const row = []
    row[data.key] = data.value
    this.setState({ formData: { ...formData, ...row} })  
  }

  requestForgotPassword = async () => {
    await this.props.forgotPassord(this.state.formData).then(() => {
      if (this.props.error && this.props.error !== '') this.setState({error: this.props.error})
      if (this.props.success && this.props.success !== '') this.setState({success: 'An e-mail will have been sent to you at the address that you provided '})
    }).catch((err) => {
      console.log(err)
    })
  }

  render () {
    const { fields } = this.props
    const { error, success } = this.state

    return (
      <div className='forgot-password'>
        <form className={Form} onSubmit={this.requestForgotPassword}>
          {
            fields && fields.email && (
              <Field onChange={this.addFormData} type="email" id={fields.email.id} name={fields.email.name} value={fields.email.value} className=""> Your email </Field>
            )
          }
          {
            fields && fields['_token'] && (
              <Field onChange={this.addFormData} type="hidden" id={fields['_token'].id} name={fields['_token'].name} value={fields['_token'].value} > Your email </Field>
            )
          }
         
          <Button type='submit' onCallback={this.requestForgotPassword}> 
            <User width="24" height="24" /> Get a new password 
          </Button>
          {
              error !== '' && (
                <Error>{error}</Error>
              )
            }
            {
              success !== '' && (
                <Success>{success}</Success>
              )
            }
        </form>
        <div className="forgot-password--bottom">
          <Link to="/login" className={LinkButtonStyle}><User width="24" height="24" /> <span className="btn--label"> Login page </span> </Link>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    fields: Session.forgot_password.fields,
    error: Session.error && Session.error.message,
    success: Session.error && Session.error.success
  }),
  dispatch => ({
    forgotPassord: fields => dispatch(SforgotPassword(fields))
  })
)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/scenes/Auth/Pages/ForgotPassword.js